<template lang="pug">
div
  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.orange
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/1.png")
    el-col(:span="22").text-dashedBox
      ul
        li Antes de comprar uma área você deve exigir do vendedor que demonstre:
        ul
          li a cadeia dominial completa da área (documento do cartório que conta toda a história da área desde o seu primeiro dono);
          li a confirmação de que a área tem um título de terras expedido pelo Poder Público em nome do primeiro dono;
          li que este título em nome do primeiro dono tem a mesma localização ao da área que o vendedor quer lhe vender;
          li caso a área tenha documentos e você tenha dúvidas se ele legítimo ou não procure um especialista no assunto ou o {{ORGAO}} para te orientar;
          li caso a área tenha documentos frágeis ou não tenha nenhum documento, tome as orientações abaixo:
          ul
            li
              i Obs: Procure o Cartorário do Registro de Imóveis da localidade do imóvel para te orientar ou entre em contato com (91) 3181 6500.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.red
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/2.png")
    el-col(:span="22").text-dashedBox
      ul
        li O Cadastro Ambiental Rural (CAR), a Declaração do {{SISTEMA}} e escrituras públicas de compra e venda
          |  ou contratos particulares não são documentos que comprovam a propriedade privada ou direitos sobre
          |  a terra, e nem servem como garantia que a área será regularizada.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.orange
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/3.png")
    el-col(:span="22").text-dashedBox
      ul
        li Um título de terras expedido pelo {{ORGAO}} não autoriza desmatar. Para qualquer supressão de floresta você deverá obter a licença ambiental.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.red
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/4.png")
    el-col(:span="22").text-dashedBox
      ul
        li Um título de terras somente é expedido após o cumprimento de todo procedimento legal que envolve
          |  análises jurídica e técnica (cartográfica, fiscalização de georreferenciamento e vistoria de campo).

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.orange
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/5.png")
    el-col(:span="22").text-dashedBox
      ul
        li A partir de 2019 o {{ORGAO}} passou a utilizar imagens de satélites de alta resolução para identificar as áreas,
          |  a situação da floresta e a atividade produtiva.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.orange
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/6.png")
    el-col(:span="22").text-dashedBox
      ul
        li A partir de agosto de 2020 o {{ORGAO}} fará a utilização de dados ambientais da SEMAS e do IDEFLOR-Bio,
          |  bem como de dados de produção da SEDAP, EMATER, SEDEME e ADEPARÁ com objetivo de avaliar o processo
          |  de ocupação e uso da área para fins de comprovação de atividade produtiva pelo requerente da regularização.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.red
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/7.png")
    el-col(:span="22").text-dashedBox
      ul
        li Confirme se a área tem algum passivo ambiental, multa ou embargo do IBAMA, da Secretaria Estadual de Meio Ambiente
          |  ou da Secretaria Municipal de Meio Ambiente
          span &nbsp (acesse:
          el-button(
            type="text"
            style="font-size: 1em"
          )
            a(
              target="_blank"
              href="http://www.semas.pa.gov.br"
              style="text-decoration:none"
              )
              span.url www.semas.pa.gov.br
          |)

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.red
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/8.png")
    el-col(:span="22").text-dashedBox
      ul
        li O que você precisa saber antes de pedir a regularização de uma área no {{ORGAO}}:
        ul
          li o que o {{ORGAO}} faz:
          ul
            li 1.  regulariza áreas de domínio do Estado do Pará;
            li 2. regulariza áreas que nunca foram tituladas;
          li O que o {{ORGAO}} não faz:
          ul
            li 1. não regulariza áreas da União, do INCRA e de municípios;
            li 2. não regulariza áreas em Unidades de Conservação federais, territórios criados ou de pretensão quilombolas,
              |  de comunidades tradicionais em terras da União, territórios indígenas criados ou em estudo,
              |  terrenos de marinha e seus acrescidos;
            li 3. não regulariza Unidades de Conservação estaduais em que não é permitida a propriedade privada;
              |  territórios criados ou de pretensão quilombolas, de comunidades tradicionais em terras do Estado do Pará
              |  criados ou sob pretensão; áreas destinadas para concessão florestal de acordo com o IDEFLOR-Bio.

        br
        li
          i Obs: Os informativos têm natureza meramente exemplificativa, podendo ocorrer outras situações.
        li
          i Para saber se a área do seu interesse não recai em áreas impedidas, consulte o mapa do {{SISTEMA}}
            |  que tem natureza orientativa acessando o link: &nbsp
            el-button(
              type="text"
              style="font-size: 1em"
            )
              a(
                target="_blank"
                href="http://sicarf.iterpa.pa.gov.br/"
                style="text-decoration:none"
              )
                span.url sicarf.iterpa.pa.gov.br
            |)
        li
          i Obs: a confirmação que a área não está em espaço impedido, não gera expectativa de direito à regularização fundiária.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.red
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/9.png")
    el-col(:span="22").text-dashedBox
      ul
        li O {{ORGAO}} apenas entrará em contato como você pelos seus canais oficiais que estão dispostos nesta página.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.orange
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/10.png")
    el-col(:span="22").text-dashedBox
      ul
        li Se alguém entrar em contato com você em nome do {{ORGAO}}, peça o número da matrícula funcional da pessoa ou do seu credenciamento.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.orange
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/11.png")
    el-col(:span="22").text-dashedBox
      ul
        li Ninguém está autorizado em falar em nome do {{ORGAO}} e nem vender serviços privados de regularização fundiária em seu nome;

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.red
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/12.png")
    el-col(:span="22").text-dashedBox
      ul
        li Caso alguém queira vender serviços de regularização fundiária em nome do {{ORGAO}},
          |  primeiro pegue os dados da matrícula funcional, número do credenciado e/ou contatos (e-mail e telefone).
          |  Em seguida, entre em contato com o {{ORGAO}} para obter a confirmação.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.orange
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/13.png")
    el-col(:span="22").text-dashedBox
      ul
        li Ninguém está autorizado a utilizar os símbolos do {{ORGAO}} ou do Governo do Estado do Pará visando presumir
          |  ser servidor público ou obter facilidades em processos de regularização fundiária.
          |  Para se prevenir de golpes e problemas futuros, adote o procedimento indicado no item 12.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.red
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/14.png")
    el-col(:span="22").text-dashedBox
      ul
        li A partir de junho de 2020 todos os documentos do {{ORGAO}} somente terão validade se expedidos com certificado digital
          |  e assinatura eletrônica, que você poderá comprovar a autenticidade pelo aplicativo ou portal {{SISTEMA}} do {{ORGAO}},
          |  sem a necessidade de dirigir-se ao órgão fundiário.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.orange
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/15.png")
    el-col(:span="22").text-dashedBox
      ul
        li Prestar informação falsa em pedidos dos serviços do {{ORGAO}} é crime que sujeita a pessoa à responsabilidade criminal
          |  e a nulidade do processo de regularização fundiária e do título, caso tenha sido expedido.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.red
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/16.png")
    el-col(:span="22").text-dashedBox
      ul
        li Leia atentamente o que está escrito no seu título. Nele constam obrigações que você deve atender.
          |  No caso do não atendimento ou violação ele poderá ser cancelado e a área retomada pelo Estado.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.orange
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/17.png")
    el-col(:span="22").text-dashedBox
      ul
        li Além dos símbolos do {{ORGAO}} e do Governo do Estado leia sempre o conteúdo do documento expedido pelo órgão fundiário.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.red
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/18.png")
    el-col(:span="22").text-dashedBox
      ul
        li Você sabe como você pode acelerar a análise do seu pedido de regularização fundiária?
        ul
          li protocole todos os documentos do requerente corretamente e legíveis (boa definição);
          li protocole todas as peças técnicas de georreferenciamento e no formato correto;
          li preste todas as informações solicitadas com clareza, objetividade e honestidade;
          li responda da forma correta e o mais breve possível as notificações feitas pelo órgão.
        br
        li
          i Obs: lembre-se que, quanto mais organizado e com os documentos corretos, o seu pedido será analisado com mais rapidez
            |  porque você não perderemos tempo te notificando e você levando tempo para responder.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.red
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/19.png")
    el-col(:span="22").text-dashedBox
      ul
        li Quando o seu processo é arquivado você deverá pagar custas para o desarquivamento.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.red
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/20.png")
    el-col(:span="22").text-dashedBox
      ul
        li Em breve, o {{ORGAO}} disponibilizará no seu site e no portal {{SISTEMA}} a lista dos profissionais com credenciamento
          |  no órgão para execução do georreferenciamento e vistoria da regularização fundiária onerosa ou não onerosa. O {{ORGAO}} não se responsabiliza pela relação contratual entre as partes
          |  que tem a natureza de direito privado. Caberá apenas ao {{ORGAO}}, no caso de má conduta e/ou baixa qualidade da prestação
          |  de serviço de georreferenciamento e/ou vistoria, suspender e/ou cancelar o credenciamento, bem como comunicar o órgão de classe competente
          |  acerca da falta, após o devido processo legal.

  el-row.dashedBox
    i.fa.fa-exclamation-circle.iconExclamation.orange
    el-col(:span="2").icon-dashedBox
      img(src="@/assets/icons/IconesObservacoes/21.png")
    el-col(:span="22").text-dashedBox
      ul
        li  Se você tomar conhecimento de alguma irregularidade use o nosso canal de denúncia.
         |  Nos ajude a combater a grilagem de terras públicas estaduais. Garantimos o sigilo.

</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      ORGAO: state => state.userInterface.dadosEstado.ORGAO,
      SISTEMA: state => state.userInterface.dadosEstado.SISTEMA
    })
  }

}
</script>

<style lang="scss">
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/element-variables.scss';

.dashedBox {
  border: 1.8px dashed $--color-primary;
  display: flex;
  margin: 20px 0;
  border-radius: 10px;
}

.icon-dashedBox {
  background-color: $--color-primary;
  color: white;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px 0 0 8px;
}

.icon-dashedBox img {
  width: 3.8em;
}

.text-dashedBox {
  padding: 20px 20px;
}

.text-dashedBox li,
i {
  font-size: 1rem;
  line-height: 2rem;
}

.iconExclamation {
  font-size: 2.5em;
  position: absolute;
  right: -15px;
  top: -15px;
  background-color: white;
  border-radius: 0 0 100% 100%;
  border-left: 3px solid white;
}

.red {
  color: red;
}

.orange {
  color: orange;
}

.url {
  color: #009f61;
}

@media screen and (max-width: 1024px) {
  .dashedBox {
    display: flex;
    flex-direction: column;
  }

  .icon-dashedBox {
    border-radius: 8px 8px 0 0;
  }

  .icon-dashedBox {
    width: 100%;
  }

  .iconExclamation {
    background-color: none;
    border-radius: 0 0 100% 100%;
    border-left: 3px solid white;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/informacao/ObservacoesImportantes.vue